/* eslint-disable no-unused-vars */
import ApiService from "@/common/api.service";

import {
  // action types
  LOAD_DATA,
  ADD_RECORD,
  GET_RECORD,
  UPDATE_RECORD,
  DELETE_RECORD,

  // mutation types
  SET_PAGE,
  SET_DATA,
  SET_ACTIVE_DATA,
  SET_ERROR,
  IS_LOADING
} from "@/consts";

export const FETCH_DATA = (endpoint, context, params) => {
  return new Promise((resolve, reject) => {
    ApiService.query(endpoint, params)
      .then(({ data }) => {
        context.commit(SET_DATA, data.data);
        context.commit(SET_PAGE, data.meta);
        resolve(data);
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data.errors) {
            context.commit(SET_ERROR, response.data.errors);
          } else if (response.data.message) {
            if ([401, 403].indexOf(response.status) !== -1) {
              context.commit(SET_ERROR, ["Authentication Error!"]);
            } else {
              context.commit(SET_ERROR, [response.data.message]);
            }
          } else {
            context.commit(SET_ERROR, [
              "Server Error Occured: " + response.statusText
            ]);
          }
        } else {
          context.commit(SET_ERROR, ["An unknown Error Occured"]);
        }

        reject(response);
      });
  });
};
